module.exports = __webpack_public_path__ + "media/navigation/icon-squiggly-burger-9ed73d48.svg";